import SlAvailableCourses from "./../components/home/SlAvailableCourses";
import { useUser } from "../contexts/UserContext";

const HomeView = () => {
  const { courses } = useUser();

  const coursesAsTeacher = courses.filter((course) => course.role === "teacher");

  return (
    <div className="min-h-[calc(100vh-75px)] bg-gradient-to-b from-secondary/70 to-background px-4 py-6 sm:px-6 lg:px-10">
      <div className="mx-auto max-w-7xl">
        <header className="relative mb-8 overflow-hidden rounded-3xl border border-accent/30 bg-gradient-to-br from-white via-white to-accent/20 px-6 py-8 shadow-default sm:px-10 sm:py-10">
          <div className="relative z-10 max-w-2xl">
            <div className="mb-3 inline-flex items-center gap-2 rounded-full border border-accent/40 bg-white/80 px-3 py-1 text-xs font-bold uppercase tracking-[0.16em] text-txt_primary_light">
              <span className="h-2 w-2 rounded-full bg-accentdark" aria-hidden="true" />
              StudyLens · Learning space
            </div>
            <h1 className="font-MS text-3xl font-extrabold tracking-tight text-txt_primary sm:text-4xl">
              Welcome to your learning space
            </h1>
            <p className="mt-3 max-w-xl text-base leading-relaxed text-txt_primary_light sm:text-lg">
              Your courses are ready when you are. Pick one to jump in.
            </p>
          </div>
          <div className="pointer-events-none absolute -right-12 -top-20 h-56 w-56 rounded-full border-[24px] border-accent/20 sm:-right-4 sm:-top-24 sm:h-72 sm:w-72" aria-hidden="true" />
          <div className="pointer-events-none absolute right-12 top-16 h-16 w-16 rounded-full bg-accent/30 blur-xl sm:right-24 sm:top-20 sm:h-24 sm:w-24" aria-hidden="true" />
        </header>

        <main className="space-y-10">
          <section aria-labelledby="student-courses-heading">
            <div className="mb-4 flex items-end justify-between gap-4">
              <div>
                <p className="mb-1 text-xs font-bold uppercase tracking-[0.16em] text-txt_primary_light">
                  Ready to explore
                </p>
                <h2 id="student-courses-heading" className="font-MS text-2xl font-bold">
                  Subscribed Courses
                </h2>
              </div>
              <div className="hidden h-1 w-16 rounded-full bg-accent sm:block" aria-hidden="true" />
            </div>
            <SlAvailableCourses courses={courses} />
          </section>

          {coursesAsTeacher.length > 0 && (
            <section aria-labelledby="teacher-courses-heading">
              <div className="mb-4 flex items-end justify-between gap-4">
                <div>
                  <p className="mb-1 text-xs font-bold uppercase tracking-[0.16em] text-txt_primary_light">
                    Teaching
                  </p>
                  <h2 id="teacher-courses-heading" className="font-MS text-2xl font-bold">
                    Subscribed Courses as Teacher
                  </h2>
                </div>
                <div className="hidden h-1 w-16 rounded-full bg-accent sm:block" aria-hidden="true" />
              </div>
              <SlAvailableCourses courses={coursesAsTeacher} linkPostfix="/teacher_portal" />
            </section>
          )}
        </main>
      </div>
    </div>
  );
};

export default HomeView;
